import { AttachedFileDTO } from "./AttachedFileDTO";
import { TicketPriceDTO } from "./TicketPriceDTO";
import {CustomFieldDTO} from "./CustomFieldDTO";
import {CustomFieldValueDTO} from "./CustomFieldValueDTO";
import { TicketsGroupDTO } from "./tickets/TicketsGroupDTO";

export type ValidationRule = 'None' | 'Census';

export class TicketDTO {
    id: number;

    eventId: number;

    communityCode: string;

    isActive: boolean;
    title: string;

    body: string;
    summary: string;
    saleDateFrom: string;
    saleDateTo: string;
    maxByUser?: number;
    maxSales?: number;
    maxSalesPurchase?: number;
    /** Máximo efectivo por usuario para lista de espera (API: MaxByUser ?? MaxSalesPurchase ?? 10). Si viene, el front no recalcula. */
    maxAllowedForWaitingList?: number;
    startEvent: string;
    endEvent: string;
    prices: TicketPriceDTO[];
    images: any[];
    files: AttachedFileDTO[] = [];
    customFields: CustomFieldDTO[] = [];
    customFieldsValues: CustomFieldValueDTO[] = [];
    feeChargedTo: number;
    categoryId: number;
    categoryName: string;
    categoryColor: string;
    rgpd: string;

    paymentMethodId: number;
    public multipleInscriptions: boolean;
    waitingList?: boolean;
    ticketsGroups?: TicketsGroupDTO[];
    validationRule?: ValidationRule | null;
    minimumAge?: number | null;
    maximumAge?: number | null;
    queueItWaitingRoomId?: string | null;
}
